module.exports = __webpack_public_path__ + "static/media/banIot.117022e8.png";